import { debounceIfPossible } from "@faire/web/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useMemo, useRef } from "react";

import { TopOfPageContentStore } from "@faire/retailer/stores/ui/TopOfPageContentStore";

export const useCategoryPageScroll = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const filterRef = useRef<HTMLDivElement>(null);

  const scrollToTop = useMemo(
    () =>
      debounceIfPossible((params: { toResults?: boolean; toTop?: boolean }) => {
        const height = getTopOfPageContentHeight();
        let offsetTop = 0;
        if (params.toTop) {
          offsetTop = 0;
        } else if (params.toResults && filterRef.current?.offsetTop) {
          offsetTop = filterRef.current.offsetTop - height;
        } else if (scrollRef.current?.offsetTop) {
          offsetTop = scrollRef.current.offsetTop - height;
        }
        getWindowOrThrow().scrollTo?.({
          top: offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }, 100),
    []
  );

  return {
    scrollRef,
    filterRef,
    scrollToTop,
  };
};

// Non-reactive height getter - we only care about this value when we're
// scrolling to the top of the page, so we don't need to make it reactive.
const getTopOfPageContentHeight = () => {
  return TopOfPageContentStore.get().headerPlusPromoBannerHeight;
};
